import { ThunkResult } from "../../shared/utilities";
import { initializeDefaultParameterStructure, ParameterStructure } from "../model/DefaultParametersInitializer";
import { HttpBinaryResultParameterSchema, HttpResultParameterSchema } from "../model/HttpResultParameterSchema";
import { IAction } from "../model/IAction";
import { ElementType, ReturnType } from "../model/IProcessData";
import { ParameterEditorValue } from "../model/ParameterEditorValue";
import { State } from "../model/State";
import { rebuildVariableScopesAndTriggerValidationAction } from "./ValidateProcess";

export const UPDATE_SELECTED_RETURN_TYPE = "UPDATE_SELECTED_RETURN_TYPE";

export function updateSelectedReturnType(elementId: string, selectedReturnType: ReturnType, skipValidation?: boolean): ThunkResult<void, State> {
    function getParameters(currentParameters: ParameterStructure | null, elementType: ElementType): ParameterStructure {
        switch (selectedReturnType) {
            case ReturnType.Expression:
                const currentExpression = currentParameters && currentParameters["expression"];
                return {
                    expression: currentExpression || { mode: "csharp", value: "#result" }
                };
            case ReturnType.HttpResult:
                const httpResultParameters = initializeDefaultParameterStructure(HttpResultParameterSchema, currentParameters) as ParameterStructure;
                const httpResultStructure = httpResultParameters as any as HttpResultParameterStructure;
                if ((!currentParameters || !currentParameters.httpStatusCode) && elementType === ElementType.Throw) {
                    // use return code 500 by default for errors
                    httpResultStructure.httpStatusCode.value = 500;
                }
                return {
                    httpResult: httpResultParameters
                };
            case ReturnType.HttpBinaryResult:
                const httpBinaryResultParameters = initializeDefaultParameterStructure(HttpBinaryResultParameterSchema, currentParameters) as ParameterStructure;
                const httpBinaryResultStructure = httpBinaryResultParameters as any as HttpBinaryResultParameterStructure;
                if ((!currentParameters || !currentParameters.httpStatusCode) && elementType === ElementType.Throw) {
                    // use return code 500 by default for errors
                    httpBinaryResultStructure.httpStatusCode.value = 500;
                }
                return {
                    httpBinaryResult: httpBinaryResultParameters
                };

        }
    }
    return (dispatch, getState) => {
        const elements = getState().elements;
        const element = elements && elements[elementId];
        if (!element) {
            throw Error("Could not find element with ID " + elementId);
        }
        const currentParameters = elements[elementId].parameters || null;

        dispatch<UpdateSelectedReturnTypeAction>({
            type: UPDATE_SELECTED_RETURN_TYPE,
            elementId: elementId,
            selectedReturnType: ReturnType[selectedReturnType],
            parameters: getParameters(currentParameters, element.type)
        });
        if (!skipValidation) {
            dispatch(rebuildVariableScopesAndTriggerValidationAction());
        }
    };
}
export interface UpdateSelectedReturnTypeAction extends IAction {
    elementId: string;
    selectedReturnType: string;
    parameters: ParameterStructure;
}

interface HttpResultParameterStructure {
    httpStatusCode: ParameterEditorValue;
    httpContent: ParameterEditorValue;
    httpContentType: ParameterEditorValue;
    httpContentEncoding: ParameterEditorValue;
    httpHeaders: [{ Key: string, Value: string }];
}

interface HttpBinaryResultParameterStructure {
    httpStatusCode: ParameterEditorValue;
    httpContentBytes: ParameterEditorValue;
    httpContentType: ParameterEditorValue;
    httpHeaders: [{ Key: string, Value: string }];
}
